module.exports = __webpack_public_path__ + "media/images/landing_page/2023/webpage/majaslapa-diziani-8801ea6eeb247f8c8286becb83ab5048.webp";